import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getModalOpen } from 'services/modal/selectors'

import {
  ADD_VENDOR_MODAL,
  OPEN_SAVE_NEW_SEARCH_MODAL,
  RESEND_INVITATION_MODAL,
} from 'services/modal/constants'
import { closeModal } from 'services/modal/actions'
import AddVendorModal from 'containers/AddVendorModal'
import ResendInvitationModal from 'containers/ResendInvitationModal'
import SaveNewSearchModal from 'containers/SaveNewSearchModal'

const ModalManager = () => {
  const dispatch = useDispatch()
  const modalOpen = useSelector(getModalOpen)

  const handleCloseModal = () => {
    dispatch(closeModal())
  }

  if (modalOpen === ADD_VENDOR_MODAL)
    return <AddVendorModal isOpen={true} onClose={handleCloseModal} />
  if (modalOpen && modalOpen.open === RESEND_INVITATION_MODAL)
    return (
      <ResendInvitationModal
        id={modalOpen.id}
        email={modalOpen.email}
        isOpen={true}
        onClose={handleCloseModal}
      />
    )
  if (modalOpen === OPEN_SAVE_NEW_SEARCH_MODAL)
    return <SaveNewSearchModal isOpen={true} onClose={handleCloseModal} />

  return <></>
}

export default ModalManager
